import { TextField } from "@mui/material";

const InputComponent = ({ col, label, variant, type, disabled, onChange, defaultValue, size, register, name, required, shrink, error, helperText }: { col: number, label: string, variant?: any, type?: any, disabled?: boolean, onChange?: any, defaultValue?: any, size?: any, register?: any, name?: any, required?: boolean, shrink?: boolean, error?: boolean, helperText?: string }) => {
    return (
        <div className={`col-md-${col} mb-4`}>
            {
                register

                    ?

                    <TextField
                        label={label}
                        variant={variant ? variant : "outlined"}
                        className={"w-100"}
                        color={"primary"}
                        {...register(name, { required: required })}
                        name={name}
                        type={type ? type : "text"}
                        disabled={disabled ? true : false}
                        onChange={onChange}
                        defaultValue={defaultValue}
                        size={size ? size : "medium"}
                        InputLabelProps={{ shrink: shrink }}
                        error={error}
                        helperText={error ? helperText : ''}
                    />

                    :

                    <TextField
                        label={label}
                        variant={variant ? variant : "outlined"}
                        className={"w-100"}
                        color={"primary"}
                        type={type ? type : "text"}
                        disabled={disabled ? true : false}
                        onChange={onChange}
                        defaultValue={defaultValue}
                        size={size ? size : "medium"}
                        InputLabelProps={{ shrink: shrink }}
                        required={required}
                    />
            }
        </div>
    )
}

export default InputComponent;